import { createEffect } from 'effector';
import { EffectCallbacks } from '../../shared/effect-callbacks';

const PATH = 'api-applications/api/v2/classifiers';
const Callbacks = new EffectCallbacks(PATH);

// Create an effect that makes a GET request for a back
export const getClassifiersFX = createEffect(Callbacks.fetchList);
